import { ALLOWED_FILE_EXTENSIONS, MAX_FILE_SIZE_MB } from '../constants/fileUploadLimits';

/** How many files can be picked, of which types, and how large. */
export const UploadDirections = ({ maxFiles }: { maxFiles: number }) => {
    // ".pdf", ".png", ".jpg", ".txt" as "pdf, png, jpg and txt"
    const types = ALLOWED_FILE_EXTENSIONS.map((extension) => extension.slice(1));
    const typeList = `${types.slice(0, -1).join(', ')} and ${types[types.length - 1]}`;

    return (
        // Indented so the bullets sit inside the content's left edge, in line with "Type:" and the drop zone, rather than
        // hanging out past it
        <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
            {maxFiles > 1 ? (
                <li>
                    You may select up to <b>{maxFiles}</b> files. Any others beyond that will NOT be uploaded.
                </li>
            ) : (
                <li>Please select or drop only 1 file to upload</li>
            )}
            <li>Only {typeList} file types are allowed</li>
            <li>Maximum file size is {MAX_FILE_SIZE_MB} MB/document</li>
        </ul>
    );
};
